import { z } from 'zod';

import { PeoPayrollProviderCompanyType, SignUpMethod } from 'src/api';

import {
  PeoPayrollProviderSettingsFormFields,
  PeoPayrollProviderSettingsFormValues,
} from '../types';

export const peoPayrollProviderSettingsFormValidationSchema = z.object({
  [PeoPayrollProviderSettingsFormFields.companyType]: z.enum(PeoPayrollProviderCompanyType),
  [PeoPayrollProviderSettingsFormFields.signUpMethod]: z.enum(SignUpMethod),
  [PeoPayrollProviderSettingsFormFields.pinHint]: z
    .string()
    .max(200, 'PIN Hint must be at most 200 characters')
    .nullish(),
}) satisfies z.ZodType<PeoPayrollProviderSettingsFormValues>;
